module.exports = "/images/youtube-icon.svg";